/**
 * Form Field Mappings - Typed layer between Angular form controls and Excel columns
 *
 * This mapping ensures that form control names are decoupled from Excel column names.
 * When Excel columns are renamed, this mapping must be updated.
 *
 * Structure: FormControlKey => ExcelColumnName
 */

// ============================================================================
// FORM FIELD KEYS - Used as form control names in Angular
// ============================================================================

export const FORM_FIELDS = {
  // Basis Info Fields
  BASIS_INFO: {
    CUSTOMER: 'Customer',
    COUNTRY: 'Country',
    LOCATION: 'Location',
    CONTACT_RC: 'ContactRC',
    REMARKS_FIELD: 'remarks field',
    SIMPLE_CALC: 'simplecalc',
    SERVICE_TEXT_1: 'servicetext1',
    SERVICE_TEXT_2: 'servicetext2',
    SERVICE_TEXT_3: 'servicetext3',
    SERVICE_TEXT_4: 'servicetext4',
    SERVICE_TEXT_5: 'servicetext5',
    SERVICE_TEXT_6: 'servicetext6',
    SERVICE_TEXT_7: 'servicetext7',
    SERVICE_TEXT_8: 'servicetext8',
    SELECTION: 'selection',
    HOST_COUNT: 'hostcount',
    MLFB_SHORT_1: 'MLFBshort1',
    MLFB_SHORT_2: 'MLFBshort2',
    MLFB_SHORT_3: 'MLFBshort3',
    MLFB_SHORT_4: 'MLFBshort4',
    MLFB_SHORT_5: 'MLFBshort5',
    MLFB_SHORT_6: 'MLFBshort6',
    MLFB_SHORT_7: 'MLFBshort7',
    MLFB_SHORT_8: 'MLFBshort8',
    MLFB_SHORT_9: 'MLFBshort9',
    MLFB_1: 'MLFB1',
    MLFB_2: 'MLFB2',
    MLFB_3: 'MLFB3',
    MLFB_4: 'MLFB4',
    MLFB_5: 'MLFB5',
    MLFB_6: 'MLFB6',
    MLFB_7: 'MLFB7',
    MLFB_8: 'MLFB8',
    MLFB_9: 'MLFB9',
    MLFB_SELECTED: 'MLFBselected',
    CUSTOMER_TOOLTIP: 'Customertooltiptext',
    COUNTRY_TOOLTIP: 'Countrytooltiptext',
    LOCATION_TOOLTIP: 'Locationtooltiptext',
    CONTACT_RC_TOOLTIP: 'ContactRCtooltiptext',
    REMARKS_FIELD_TOOLTIP: 'remarks fieldtooltiptext',
    SIMPLE_CALC_TOOLTIP: 'simplecalctooltiptext',
    SELECTION_TOOLTIP: 'selectiontooltiptext',
    HOST_COUNT_TOOLTIP: 'hostcounttooltiptext'
  },

  // Equipment Inventory Fields
  EQUIPMENT_INVENTORY: {
    ENGINEERING_STATION: 'Engineeringstation',
    OS_SERVERS_BATCH_ROUTE_CONTROL: 'OSServersincluding_BatchandRoutecontrol',
    OS_CLIENTS: 'OSClients',
    DATA_CLIENTS: 'Dataclients',
    OTHER_PRODUCTION_SYSTEMS: 'OtherProductionsystems',
    DATA_EXCHANGE_SERVER: 'DataExchangeServer',
    JUMPHOST: 'Jumphost',
    DOMAIN: 'Domain',
    NETWORK_MONITOR_SERVER: 'NetworkMonitorServer',
    MANAGEMENT: 'Management',
    DNS: 'DNS',
    ENDPOINT_PROTECTION: 'EndpointProtection',
    INFORMATION_SERVER: 'InformationServer',
    UPDATE_SERVER_WSUS: 'UpdateServer_WSUS',
    OTHER_WINDOWS: 'OtherWindows',
    OTHER_OS: 'OtherOS',
    HOSTS: 'Hosts',
    SAN_VSAN_SOLUTION: 'SAN_vSANsolution',
    IDMZ_HOST: 'iDMZhost',
    CORE_SWITCHES: 'coreswitches',
    FIREWALLS: 'firewalls',
    SIDSIB_AND_R: 'SIDSIB&R',
    PH: 'PH',
    UPS: 'UPS',
    NAS: 'NAS',
    USB_CONNECTOR_HUB: 'USBconnectorHUB',
    THIN_CLIENTS: 'Thinclients',
    SWITCHES_PCN: 'SwitchesPCN',
    SWITCHES_CSN: 'SwitchesCSN',
    SWITCHES_FSN: 'SwitchesFSN',
    PLC_AS: 'PLC-AS',
    PLC_AS_VISIBLE: 'PLC-ASvisible',
    ENGINEERING_STATION_TOOLTIP: 'Engineeringstationtooltiptext',
    OS_SERVERS_BATCH_ROUTE_CONTROL_TOOLTIP: 'OSServersincluding_BatchandRoutecontroltooltiptext',
    OS_CLIENTS_TOOLTIP: 'OSClientstooltiptext',
    DATA_CLIENTS_TOOLTIP: 'Dataclientstooltiptext',
    OTHER_PRODUCTION_SYSTEMS_TOOLTIP: 'OtherProductionsystemstooltiptext',
    DATA_EXCHANGE_SERVER_TOOLTIP: 'DataExchangeServertooltiptext',
    JUMPHOST_TOOLTIP: 'Jumphosttooltiptext',
    DOMAIN_TOOLTIP: 'Domaintooltiptext',
    NETWORK_MONITOR_SERVER_TOOLTIP: 'NetworkMonitorServertooltiptext',
    MANAGEMENT_TOOLTIP: 'Managementtooltiptext',
    DNS_TOOLTIP: 'DNStooltiptext',
    ENDPOINT_PROTECTION_TOOLTIP: 'EndpointProtectiontooltiptext',
    INFORMATION_SERVER_TOOLTIP: 'InformationServertooltiptext',
    UPDATE_SERVER_WSUS_TOOLTIP: 'UpdateServer_WSUStooltiptext',
    OTHER_WINDOWS_TOOLTIP: 'OtherWindowstooltiptext',
    OTHER_OS_TOOLTIP: 'OtherOStooltiptext',
    HOSTS_TOOLTIP: 'Hoststooltiptext',
    SAN_VSAN_SOLUTION_TOOLTIP: 'SAN_vSANsolutiontooltiptext',
    IDMZ_HOST_TOOLTIP: 'iDMZhosttooltiptext',
    CORE_SWITCHES_TOOLTIP: 'coreswitchestooltiptext',
    FIREWALLS_TOOLTIP: 'firewallstooltiptext',
    SIDSIB_AND_R_TOOLTIP: 'SIDSIB&Rtooltiptext',
    PH_TOOLTIP: 'PHtooltiptext',
    UPS_TOOLTIP: 'UPStooltiptext',
    NAS_TOOLTIP: 'NAStooltiptext',
    USB_CONNECTOR_HUB_TOOLTIP: 'USBconnectorHUBtooltiptext',
    THIN_CLIENTS_TOOLTIP: 'Thinclientstooltiptext',
    TOOLTIP_TEXT: 'tooltiptext',
    SWITCHES_PCN_TOOLTIP: 'SwitchesPCNtooltiptext',
    SWITCHES_CSN_TOOLTIP: 'SwitchesCSNtooltiptext',
    SWITCHES_FSN_TOOLTIP: 'SwitchesFSNtooltiptext',
    PLC_AS_TOOLTIP: 'PLC-AStooltiptext',
    PLC_AS_VISIBLE_TOOLTIP: 'PLC-ASvisibletooltiptext'
  },

  // Services Fields
  SERVICES: {
    CONTINUOUS_MONITORING: 'ContinuousMonitoring',
    INCIDENT_MANAGEMENT: 'IncidentManagement',
    NETWORK_MANAGEMENT: 'NetworkManagement',
    DOMAIN_MANAGEMENT: 'DomainManagement',
    SCHEDULE_FREQUENCY_PP: 'SchedulefrequencyPP',
    PREVENTIVE_PERIODIC_MAINTENANCE: 'Preventive&PeriodicMaintenance',
    SCHEDULE_FREQUENCY_UP: 'SchedulefrequencyUP',
    UPDATES_PATCHES: 'Updates&pacthes',
    BACKUP_RESTORE: 'Back-up&Restore',
    VULNERABILITY_MANAGEMENT: 'VulnerabilityManagement',
    ANOMALY_DETECTION: 'AnomalyDetection',
    SOCAAS: 'SOCaaS',
    REMOTE_SUPPORT: 'RemoteSupport',
    SERVICE_DESK: 'ServiceDesk',
    SERVICE_REQUEST: 'ServiceRequest',
    SERVICE_REQUEST_HOURS: 'ServiceRequesthours',
    CRSP: 'cRSP',
    ONBOARDING_CUSTOMER: 'onboardingcustomer',
    ONBOARDING_ANOMALY: 'onboardinganomaly',
    ONBOARDING_ANOMALY_VISIBLE: 'onboardinganomalyvisible',
    ONBOARDING_SOCAAS: 'onboardingSOCaaS',
    ONBOARDING_SOCAAS_VISIBLE: 'onboardingSOCaaSvisible',
    CONTINUOUS_MONITORING_TOOLTIP: 'ContinuousMonitoringtooltiptext',
    INCIDENT_MANAGEMENT_TOOLTIP: 'IncidentManagementtooltiptext',
    NETWORK_MANAGEMENT_TOOLTIP: 'NetworkManagementtooltiptext',
    DOMAIN_MANAGEMENT_TOOLTIP: 'DomainManagementtooltiptext',
    SCHEDULE_FREQUENCY_PP_TOOLTIP: 'SchedulefrequencyPPtooltiptext',
    PREVENTIVE_PERIODIC_MAINTENANCE_TOOLTIP: 'Preventive&PeriodicMaintenancetooltiptext',
    SCHEDULE_FREQUENCY_UP_TOOLTIP: 'SchedulefrequencyUPtooltiptext',
    UPDATES_PATCHES_TOOLTIP: 'Updates&pacthestooltiptext',
    BACKUP_RESTORE_TOOLTIP: 'Back-up&Restoretooltiptext',
    VULNERABILITY_MANAGEMENT_TOOLTIP: 'VulnerabilityManagementtooltiptext',
    ANOMALY_DETECTION_TOOLTIP: 'AnomalyDetectiontooltiptext',
    SOCAAS_TOOLTIP: 'SOCaaStooltiptext',
    REMOTE_SUPPORT_TOOLTIP: 'RemoteSupporttooltiptext',
    SERVICE_DESK_TOOLTIP: 'ServiceDesktooltiptext',
    SERVICE_REQUEST_TOOLTIP: 'ServiceRequesttooltiptext',
    SERVICE_REQUEST_HOURS_TOOLTIP: 'ServiceRequesthourstooltiptext',
    CRSP_TOOLTIP: 'cRSPtooltiptext',
    ONBOARDING_CUSTOMER_TOOLTIP: 'onboardingcustomertooltiptext',
    ONBOARDING_ANOMALY_TOOLTIP: 'onboardinganomalytooltiptext',
    ONBOARDING_ANOMALY_VISIBLE_TOOLTIP: 'onboardinganomalyvisibletooltiptext',
    ONBOARDING_SOCAAS_TOOLTIP: 'onboardingSOCaaStooltiptext',
    ONBOARDING_SOCAAS_VISIBLE_TOOLTIP: 'onboardingSOCaaSvisibletooltiptext'
  },

  // Pricing Fields
  PRICING: {
    CONTRACT_DURATION: 'Contractduration',
    TYPE_OF_PRICING: 'typeofpricing',
    INDEXATION: 'indexation',
    INDEXATION_VISIBLE: 'indexationvisible',
    ACTIVATE_DISCOUNT: 'activatediscount',
    INDEX_DISCLAIMER: 'indexdisclaimer',
    SIMPLE_CALC: 'simplecalc',
    CONTRACT_DURATION_TOOLTIP: 'Contractdurationtooltiptext',
    TYPE_OF_PRICING_TOOLTIP: 'typeofpricingtooltiptext',
    INDEXATION_TOOLTIP: 'indexationtooltiptext',
    INDEXATION_VISIBLE_TOOLTIP: 'indexationvisibletooltiptext',
    ACTIVATE_DISCOUNT_TOOLTIP: 'activatediscounttooltiptext',
    INDEX_DISCLAIMER_TOOLTIP: 'indexdisclaimertooltiptext'
  },

  // Contract Fields
  CONTRACT: {
    TYPE_OF_PRICING_1: 'typeofpricing1',
    ONBOARDING_TOTAL: 'onboarding_total',
    RIOPS_PACKAGE_PRICE: 'RIOpSpackageoprice',
    RIOPS_PACKAGE_TEXT: 'RIOpspackacketext',
    RIOPS_DISCOUNT: 'RIOpSDiscount',
    RIOPS_DISCOUNT_VISIBLE: 'RIOpSDiscountVisible',
    TOTAL_PRICE: 'totalprice',
    GENERAL_DISCLAIMER_TEXT: 'genernaldisclaimertext',
    VERSION_TEXT: 'Versiontext',
    DESCRIPTION_TEXT: 'descriptiontext',
    TYPE_OF_PRICING_1_TOOLTIP: 'typeofpricing1tooltiptext',
    ONBOARDING_TOTAL_TOOLTIP: 'onboarding_totaltooltiptext',
    RIOPS_PACKAGE_PRICE_TOOLTIP: 'RIOpSpackageopricetooltiptext',
    RIOPS_PACKAGE_TEXT_TOOLTIP: 'RIOpspackacketexttooltiptext',
    RIOPS_DISCOUNT_TOOLTIP: 'RIOpSDiscounttooltiptext',
    TOTAL_PRICE_TOOLTIP: 'totalpricetooltiptext',
    GENERAL_DISCLAIMER_TEXT_TOOLTIP: 'genernaldisclaimertexttooltiptext',
    VERSION_TEXT_TOOLTIP: 'Versiontexttooltiptext',
    DESCRIPTION_TEXT_TOOLTIP: 'descriptiontexttooltiptext',
    RIOPS_DISCOUNT_VISIBLE_TOOLTIP: 'RIOpSDiscountVisibletooltiptext'
  }
} as const;

// ============================================================================
// TYPE DEFINITIONS - Ensures type safety when accessing Excel field names
// ============================================================================

/** Excel column names for Basis Info form */
export type BasisInfoExcelField = (typeof FORM_FIELDS.BASIS_INFO)[keyof typeof FORM_FIELDS.BASIS_INFO];

/** Excel column names for Equipment Inventory form */
export type EquipmentInventoryExcelField =
  (typeof FORM_FIELDS.EQUIPMENT_INVENTORY)[keyof typeof FORM_FIELDS.EQUIPMENT_INVENTORY];

/** Excel column names for Services form */
export type ServicesExcelField = (typeof FORM_FIELDS.SERVICES)[keyof typeof FORM_FIELDS.SERVICES];

/** Excel column names for Pricing form */
export type PricingExcelField = (typeof FORM_FIELDS.PRICING)[keyof typeof FORM_FIELDS.PRICING];

/** Excel column names for Contract form */
export type ContractExcelField = (typeof FORM_FIELDS.CONTRACT)[keyof typeof FORM_FIELDS.CONTRACT];

/** Union of all Excel field names */
export type ExcelField =
  | BasisInfoExcelField
  | EquipmentInventoryExcelField
  | ServicesExcelField
  | PricingExcelField
  | ContractExcelField;

// ============================================================================
// HELPER FUNCTION
// ============================================================================

/**
 * Creates a form control object with all fields from a category
 * Usage: this.form = this.fb.group(createFormControls(FORM_FIELDS.BASIS_INFO))
 */
export function createFormControls(fieldCategory: Record<string, string>): Record<string, [string]> {
  const controls: Record<string, [string]> = {};
  Object.entries(fieldCategory).forEach(([, value]) => {
    controls[value] = [''];
  });
  return controls;
}
